'use strict';

const jQuery = require('jquery');

const FormBuilder = require('./../builder');

FormBuilder.register('submit', function(config) {
    let self = this;

    this.form = config.form;
    this.elementClass = config.elementClass || 'btn btn-primary';
    this.wrapClass = config.wrapClass || '';
    this.label = config.label;
    this.config = config;

    this.render = function() {
        let $element = jQuery('<button></button>');

        $element.attr('type', 'submit');
        $element.text(this.label);

        if (self.elementClass) {
            $element.addClass(self.elementClass);
        }

        $element.on('click', function() {
            self.form.submit();

            return false;
        });

        return $element;
    };
});
